import React, { forwardRef } from 'react';
import {
  AppWindow as PhAppWindow,
  Archive as PhArchive,
  ArrowBendUpLeft as PhArrowBendUpLeft,
  ArrowBendUpRight as PhArrowBendUpRight,
  ArrowClockwise as PhArrowClockwise,
  ArrowCounterClockwise as PhArrowCounterClockwise,
  ArrowDown as PhArrowDown,
  ArrowLeft as PhArrowLeft,
  ArrowRight as PhArrowRight,
  ArrowSquareOut as PhArrowSquareOut,
  ArrowUp as PhArrowUp,
  ArrowUpRight as PhArrowUpRight,
  ArrowsClockwise as PhArrowsClockwise,
  ArrowsIn as PhArrowsIn,
  ArrowsInSimple as PhArrowsInSimple,
  ArrowsLeftRight as PhArrowsLeftRight,
  ArrowsOut as PhArrowsOut,
  ArrowsOutSimple as PhArrowsOutSimple,
  Bank as PhBank,
  Bell as PhBell,
  BellRinging as PhBellRinging,
  BellSlash as PhBellSlash,
  BookOpen as PhBookOpen,
  BookmarkSimple as PhBookmarkSimple,
  Books as PhBooks,
  Brain as PhBrain,
  Briefcase as PhBriefcase,
  Broadcast as PhBroadcast,
  Bug as PhBug,
  Buildings as PhBuildings,
  CalendarBlank as PhCalendarBlank,
  CalendarCheck as PhCalendarCheck,
  CalendarDots as PhCalendarDots,
  CalendarPlus as PhCalendarPlus,
  Camera as PhCamera,
  CaretDoubleUp as PhCaretDoubleUp,
  CaretDown as PhCaretDown,
  CaretLeft as PhCaretLeft,
  CaretRight as PhCaretRight,
  CaretUp as PhCaretUp,
  CellSignalFull as PhCellSignalFull,
  ChartBar as PhChartBar,
  ChartLine as PhChartLine,
  ChartPie as PhChartPie,
  Chat as PhChat,
  ChatCircle as PhChatCircle,
  ChatText as PhChatText,
  Chats as PhChats,
  Check as PhCheck,
  CheckCircle as PhCheckCircle,
  CheckSquare as PhCheckSquare,
  Checks as PhChecks,
  Circle as PhCircle,
  CircleDashed as PhCircleDashed,
  CircleNotch as PhCircleNotch,
  Clipboard as PhClipboard,
  ClipboardText as PhClipboardText,
  Clock as PhClock,
  ClockCounterClockwise as PhClockCounterClockwise,
  Cloud as PhCloud,
  CloudArrowDown as PhCloudArrowDown,
  CloudArrowUp as PhCloudArrowUp,
  Code as PhCode,
  Coffee as PhCoffee,
  Coins as PhCoins,
  Compass as PhCompass,
  Copy as PhCopy,
  Cpu as PhCpu,
  CreditCard as PhCreditCard,
  Crown as PhCrown,
  CurrencyDollar as PhCurrencyDollar,
  Cursor as PhCursor,
  Database as PhDatabase,
  DeviceMobile as PhDeviceMobile,
  Devices as PhDevices,
  DotsSixVertical as PhDotsSixVertical,
  DotsThree as PhDotsThree,
  DotsThreeVertical as PhDotsThreeVertical,
  DownloadSimple as PhDownloadSimple,
  Envelope as PhEnvelope,
  Eraser as PhEraser,
  Eye as PhEye,
  EyeSlash as PhEyeSlash,
  FileArrowDown as PhFileArrowDown,
  FileArrowUp as PhFileArrowUp,
  FileCode as PhFileCode,
  FileImage as PhFileImage,
  FilePlus as PhFilePlus,
  FileText as PhFileText,
  FileX as PhFileX,
  Files as PhFiles,
  FilmSlate as PhFilmSlate,
  FilmStrip as PhFilmStrip,
  Fire as PhFire,
  Flag as PhFlag,
  Flask as PhFlask,
  FloppyDisk as PhFloppyDisk,
  FlowArrow as PhFlowArrow,
  FolderMinus as PhFolderMinus,
  FolderOpen as PhFolderOpen,
  ForkKnife as PhForkKnife,
  Function as PhFunction,
  Funnel as PhFunnel,
  FunnelSimple as PhFunnelSimple,
  Gauge as PhGauge,
  Gear as PhGear,
  Gift as PhGift,
  GitBranch as PhGitBranch,
  Globe as PhGlobe,
  Graph as PhGraph,
  Hand as PhHand,
  Handshake as PhHandshake,
  HardDrive as PhHardDrive,
  HardDrives as PhHardDrives,
  Hash as PhHash,
  Headphones as PhHeadphones,
  House as PhHouse,
  IdentificationCard as PhIdentificationCard,
  Image as PhImage,
  ImageBroken as PhImageBroken,
  Infinity as PhInfinity,
  Info as PhInfo,
  Key as PhKey,
  Layout as PhLayout,
  Lightbulb as PhLightbulb,
  Lightning as PhLightning,
  Link as PhLink,
  LinkBreak as PhLinkBreak,
  List as PhList,
  ListChecks as PhListChecks,
  Lock as PhLock,
  LockKey as PhLockKey,
  MagicWand as PhMagicWand,
  MagnifyingGlass as PhMagnifyingGlass,
  MagnifyingGlassMinus as PhMagnifyingGlassMinus,
  MagnifyingGlassPlus as PhMagnifyingGlassPlus,
  MapPin as PhMapPin,
  Medal as PhMedal,
  Megaphone as PhMegaphone,
  Memory as PhMemory,
  Microphone as PhMicrophone,
  MicrophoneSlash as PhMicrophoneSlash,
  Minus as PhMinus,
  Money as PhMoney,
  Monitor as PhMonitor,
  MonitorArrowUp as PhMonitorArrowUp,
  MonitorPlay as PhMonitorPlay,
  Moon as PhMoon,
  MusicNote as PhMusicNote,
  Note as PhNote,
  Package as PhPackage,
  Palette as PhPalette,
  PaperPlaneTilt as PhPaperPlaneTilt,
  Paperclip as PhPaperclip,
  Pause as PhPause,
  PauseCircle as PhPauseCircle,
  PencilRuler as PhPencilRuler,
  PencilSimple as PhPencilSimple,
  Percent as PhPercent,
  Phone as PhPhone,
  PhoneSlash as PhPhoneSlash,
  PictureInPicture as PhPictureInPicture,
  Play as PhPlay,
  PlayCircle as PhPlayCircle,
  Plug as PhPlug,
  Plugs as PhPlugs,
  PlugsConnected as PhPlugsConnected,
  Plus as PhPlus,
  Power as PhPower,
  Prohibit as PhProhibit,
  Pulse as PhPulse,
  PushPin as PhPushPin,
  QrCode as PhQrCode,
  Question as PhQuestion,
  Broadcast as PhRadar,
  Receipt as PhReceipt,
  Robot as PhRobot,
  RocketLaunch as PhRocketLaunch,
  Scales as PhScales,
  Scroll as PhScroll,
  SealCheck as PhSealCheck,
  ShareNetwork as PhShareNetwork,
  Shield as PhShield,
  ShieldCheck as PhShieldCheck,
  ShieldSlash as PhShieldSlash,
  ShieldWarning as PhShieldWarning,
  ShoppingBag as PhShoppingBag,
  Shuffle as PhShuffle,
  SidebarSimple as PhSidebarSimple,
  Sigma as PhSigma,
  SignIn as PhSignIn,
  SignOut as PhSignOut,
  Sliders as PhSliders,
  SlidersHorizontal as PhSlidersHorizontal,
  Smiley as PhSmiley,
  Sparkle as PhSparkle,
  SpeakerHigh as PhSpeakerHigh,
  SpeakerSlash as PhSpeakerSlash,
  Square as PhSquare,
  SquaresFour as PhSquaresFour,
  Stack as PhStack,
  Star as PhStar,
  Storefront as PhStorefront,
  Sun as PhSun,
  Table as PhTable,
  Tag as PhTag,
  Target as PhTarget,
  Television as PhTelevision,
  Terminal as PhTerminal,
  TerminalWindow as PhTerminalWindow,
  TestTube as PhTestTube,
  TextT as PhTextT,
  Timer as PhTimer,
  Translate as PhTranslate,
  Trash as PhTrash,
  TreeStructure as PhTreeStructure,
  TrendDown as PhTrendDown,
  TrendUp as PhTrendUp,
  Trophy as PhTrophy,
  UploadSimple as PhUploadSimple,
  User as PhUser,
  UserCheck as PhUserCheck,
  UserCircle as PhUserCircle,
  UserGear as PhUserGear,
  UserMinus as PhUserMinus,
  UserPlus as PhUserPlus,
  Users as PhUsers,
  UsersThree as PhUsersThree,
  VideoCamera as PhVideoCamera,
  VideoCameraSlash as PhVideoCameraSlash,
  Wallet as PhWallet,
  Warning as PhWarning,
  WarningCircle as PhWarningCircle,
  WebhooksLogo as PhWebhooksLogo,
  WifiHigh as PhWifiHigh,
  WifiSlash as PhWifiSlash,
  Wrench as PhWrench,
  X as PhX,
  XCircle as PhXCircle
} from '@phosphor-icons/react';

// MIT-licensed Phosphor is the single Office icon family. Legacy export names
// preserve callers and CSS hooks; no proprietary Sigma assets are redistributed.
// Deliberately discard Lucide-only stroke props: Phosphor owns its path geometry.
function glyph(Icon, name) {
  const Component = forwardRef(function OfficeGlyph({ size = 20, className = '', strokeWidth, absoluteStrokeWidth, ...props }, ref) {
    const legacy = name.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
    const labelled = props['aria-label'] || props['aria-labelledby'] || props.role === 'img';
    return <Icon ref={ref} size={size} weight="duotone" aria-hidden={labelled ? undefined : true}
      focusable="false" {...props} className={`office-glyph lucide lucide-${legacy} ${className}`} data-office-glyph={name} />;
  });
  Component.displayName = name;
  return Component;
}

export const Activity = /* @__PURE__ */ glyph(PhPulse, 'Activity');
export const AlertCircle = /* @__PURE__ */ glyph(PhWarningCircle, 'AlertCircle');
export const AlertTriangle = /* @__PURE__ */ glyph(PhWarning, 'AlertTriangle');
export const AppWindow = /* @__PURE__ */ glyph(PhAppWindow, 'AppWindow');
export const Archive = /* @__PURE__ */ glyph(PhArchive, 'Archive');
export const ArchiveRestore = /* @__PURE__ */ glyph(PhArchive, 'ArchiveRestore');
export const ArrowDown = /* @__PURE__ */ glyph(PhArrowDown, 'ArrowDown');
export const ArrowLeft = /* @__PURE__ */ glyph(PhArrowLeft, 'ArrowLeft');
export const ArrowRight = /* @__PURE__ */ glyph(PhArrowRight, 'ArrowRight');
export const ArrowRightLeft = /* @__PURE__ */ glyph(PhArrowsLeftRight, 'ArrowRightLeft');
export const ArrowUp = /* @__PURE__ */ glyph(PhArrowUp, 'ArrowUp');
export const ArrowUpRight = /* @__PURE__ */ glyph(PhArrowUpRight, 'ArrowUpRight');
export const Award = /* @__PURE__ */ glyph(PhMedal, 'Award');
export const BadgeDollarSign = /* @__PURE__ */ glyph(PhSealCheck, 'BadgeDollarSign');
export const Ban = /* @__PURE__ */ glyph(PhProhibit, 'Ban');
export const Banknote = /* @__PURE__ */ glyph(PhMoney, 'Banknote');
export const BarChart3 = /* @__PURE__ */ glyph(PhChartBar, 'BarChart3');
export const Bell = /* @__PURE__ */ glyph(PhBell, 'Bell');
export const BellOff = /* @__PURE__ */ glyph(PhBellSlash, 'BellOff');
export const BellRing = /* @__PURE__ */ glyph(PhBellRinging, 'BellRing');
export const Bolt = /* @__PURE__ */ glyph(PhLightning, 'Bolt');
export const BookOpen = /* @__PURE__ */ glyph(PhBookOpen, 'BookOpen');
export const BookmarkCheck = /* @__PURE__ */ glyph(PhBookmarkSimple, 'BookmarkCheck');
export const Bot = /* @__PURE__ */ glyph(PhRobot, 'Bot');
export const Brain = /* @__PURE__ */ glyph(PhBrain, 'Brain');
export const Briefcase = /* @__PURE__ */ glyph(PhBriefcase, 'Briefcase');
export const Bug = /* @__PURE__ */ glyph(PhBug, 'Bug');
export const Building2 = /* @__PURE__ */ glyph(PhBuildings, 'Building2');
export const Cable = /* @__PURE__ */ glyph(PhPlugsConnected, 'Cable');
export const Calendar = /* @__PURE__ */ glyph(PhCalendarBlank, 'Calendar');
export const CalendarCheck = /* @__PURE__ */ glyph(PhCalendarCheck, 'CalendarCheck');
export const CalendarClock = /* @__PURE__ */ glyph(PhCalendarDots, 'CalendarClock');
export const CalendarDays = /* @__PURE__ */ glyph(PhCalendarDots, 'CalendarDays');
export const CalendarPlus = /* @__PURE__ */ glyph(PhCalendarPlus, 'CalendarPlus');
export const Camera = /* @__PURE__ */ glyph(PhCamera, 'Camera');
export const ChartColumn = /* @__PURE__ */ glyph(PhChartBar, 'ChartColumn');
export const ChartNoAxesCombined = /* @__PURE__ */ glyph(PhChartLine, 'ChartNoAxesCombined');
export const Check = /* @__PURE__ */ glyph(PhCheck, 'Check');
export const CheckCheck = /* @__PURE__ */ glyph(PhChecks, 'CheckCheck');
export const CheckCircle = /* @__PURE__ */ glyph(PhCheckCircle, 'CheckCircle');
export const CheckCircle2 = /* @__PURE__ */ glyph(PhCheckCircle, 'CheckCircle2');
export const CheckSquare = /* @__PURE__ */ glyph(PhCheckSquare, 'CheckSquare');
export const ChevronDown = /* @__PURE__ */ glyph(PhCaretDown, 'ChevronDown');
export const ChevronLeft = /* @__PURE__ */ glyph(PhCaretLeft, 'ChevronLeft');
export const ChevronRight = /* @__PURE__ */ glyph(PhCaretRight, 'ChevronRight');
export const ChevronUp = /* @__PURE__ */ glyph(PhCaretUp, 'ChevronUp');
export const ChevronsDownUp = /* @__PURE__ */ glyph(PhCaretDoubleUp, 'ChevronsDownUp');
export const Circle = /* @__PURE__ */ glyph(PhCircle, 'Circle');
export const CircleDashed = /* @__PURE__ */ glyph(PhCircleDashed, 'CircleDashed');
export const CircleHelp = /* @__PURE__ */ glyph(PhQuestion, 'CircleHelp');
export const CirclePlay = /* @__PURE__ */ glyph(PhPlayCircle, 'CirclePlay');
export const CircleUserRound = /* @__PURE__ */ glyph(PhUserCircle, 'CircleUserRound');
export const Clapperboard = /* @__PURE__ */ glyph(PhFilmSlate, 'Clapperboard');
export const ClipboardCheck = /* @__PURE__ */ glyph(PhClipboardText, 'ClipboardCheck');
export const ClipboardCopy = /* @__PURE__ */ glyph(PhClipboard, 'ClipboardCopy');
export const ClipboardList = /* @__PURE__ */ glyph(PhClipboardText, 'ClipboardList');
export const ClipboardPaste = /* @__PURE__ */ glyph(PhClipboardText, 'ClipboardPaste');
export const Clock = /* @__PURE__ */ glyph(PhClock, 'Clock');
export const Clock3 = /* @__PURE__ */ glyph(PhClock, 'Clock3');
export const Cloud = /* @__PURE__ */ glyph(PhCloud, 'Cloud');
export const CloudDownload = /* @__PURE__ */ glyph(PhCloudArrowDown, 'CloudDownload');
export const CloudUpload = /* @__PURE__ */ glyph(PhCloudArrowUp, 'CloudUpload');
export const Code = /* @__PURE__ */ glyph(PhCode, 'Code');
export const Coffee = /* @__PURE__ */ glyph(PhCoffee, 'Coffee');
export const Coins = /* @__PURE__ */ glyph(PhCoins, 'Coins');
export const Compass = /* @__PURE__ */ glyph(PhCompass, 'Compass');
export const ContactRound = /* @__PURE__ */ glyph(PhIdentificationCard, 'ContactRound');
export const Copy = /* @__PURE__ */ glyph(PhCopy, 'Copy');
export const Cpu = /* @__PURE__ */ glyph(PhCpu, 'Cpu');
export const CreditCard = /* @__PURE__ */ glyph(PhCreditCard, 'CreditCard');
export const Crown = /* @__PURE__ */ glyph(PhCrown, 'Crown');
export const Database = /* @__PURE__ */ glyph(PhDatabase, 'Database');
export const DollarSign = /* @__PURE__ */ glyph(PhCurrencyDollar, 'DollarSign');
export const Download = /* @__PURE__ */ glyph(PhDownloadSimple, 'Download');
export const Eraser = /* @__PURE__ */ glyph(PhEraser, 'Eraser');
export const Expand = /* @__PURE__ */ glyph(PhArrowsOut, 'Expand');
export const ExternalLink = /* @__PURE__ */ glyph(PhArrowSquareOut, 'ExternalLink');
export const Eye = /* @__PURE__ */ glyph(PhEye, 'Eye');
export const EyeOff = /* @__PURE__ */ glyph(PhEyeSlash, 'EyeOff');
export const FileCheck2 = /* @__PURE__ */ glyph(PhFileText, 'FileCheck2');
export const FileDown = /* @__PURE__ */ glyph(PhFileArrowDown, 'FileDown');
export const FileImage = /* @__PURE__ */ glyph(PhFileImage, 'FileImage');
export const FileJson = /* @__PURE__ */ glyph(PhFileCode, 'FileJson');
export const FilePenLine = /* @__PURE__ */ glyph(PhFileText, 'FilePenLine');
export const FilePlus2 = /* @__PURE__ */ glyph(PhFilePlus, 'FilePlus2');
export const FileStack = /* @__PURE__ */ glyph(PhFiles, 'FileStack');
export const FileText = /* @__PURE__ */ glyph(PhFileText, 'FileText');
export const FileUp = /* @__PURE__ */ glyph(PhFileArrowUp, 'FileUp');
export const FileWarning = /* @__PURE__ */ glyph(PhFileX, 'FileWarning');
export const Film = /* @__PURE__ */ glyph(PhFilmStrip, 'Film');
export const Filter = /* @__PURE__ */ glyph(PhFunnel, 'Filter');
export const Flag = /* @__PURE__ */ glyph(PhFlag, 'Flag');
export const Flame = /* @__PURE__ */ glyph(PhFire, 'Flame');
export const FlaskConical = /* @__PURE__ */ glyph(PhFlask, 'FlaskConical');
export const FolderOpen = /* @__PURE__ */ glyph(PhFolderOpen, 'FolderOpen');
export const FolderX = /* @__PURE__ */ glyph(PhFolderMinus, 'FolderX');
export const Gauge = /* @__PURE__ */ glyph(PhGauge, 'Gauge');
export const Gift = /* @__PURE__ */ glyph(PhGift, 'Gift');
export const GitBranch = /* @__PURE__ */ glyph(PhGitBranch, 'GitBranch');
export const Globe = /* @__PURE__ */ glyph(PhGlobe, 'Globe');
export const Grid2X2 = /* @__PURE__ */ glyph(PhSquaresFour, 'Grid2X2');
export const GripVertical = /* @__PURE__ */ glyph(PhDotsSixVertical, 'GripVertical');
export const Hand = /* @__PURE__ */ glyph(PhHand, 'Hand');
export const Handshake = /* @__PURE__ */ glyph(PhHandshake, 'Handshake');
export const HardDrive = /* @__PURE__ */ glyph(PhHardDrive, 'HardDrive');
export const Hash = /* @__PURE__ */ glyph(PhHash, 'Hash');
export const Headphones = /* @__PURE__ */ glyph(PhHeadphones, 'Headphones');
export const HelpCircle = /* @__PURE__ */ glyph(PhQuestion, 'HelpCircle');
export const History = /* @__PURE__ */ glyph(PhClockCounterClockwise, 'History');
export const Home = /* @__PURE__ */ glyph(PhHouse, 'Home');
export const House = /* @__PURE__ */ glyph(PhHouse, 'House');
export const Image = /* @__PURE__ */ glyph(PhImage, 'Image');
export const ImageIcon = /* @__PURE__ */ glyph(PhImage, 'ImageIcon');
export const ImageOff = /* @__PURE__ */ glyph(PhImageBroken, 'ImageOff');
export const ImagePlus = /* @__PURE__ */ glyph(PhImage, 'ImagePlus');
export const Infinity = /* @__PURE__ */ glyph(PhInfinity, 'Infinity');
export const Info = /* @__PURE__ */ glyph(PhInfo, 'Info');
export const Key = /* @__PURE__ */ glyph(PhKey, 'Key');
export const KeyRound = /* @__PURE__ */ glyph(PhKey, 'KeyRound');
export const Landmark = /* @__PURE__ */ glyph(PhBank, 'Landmark');
export const Languages = /* @__PURE__ */ glyph(PhTranslate, 'Languages');
export const Layers = /* @__PURE__ */ glyph(PhStack, 'Layers');
export const Layers3 = /* @__PURE__ */ glyph(PhStack, 'Layers3');
export const Layout = /* @__PURE__ */ glyph(PhLayout, 'Layout');
export const LayoutDashboard = /* @__PURE__ */ glyph(PhSquaresFour, 'LayoutDashboard');
export const LayoutGrid = /* @__PURE__ */ glyph(PhSquaresFour, 'LayoutGrid');
export const Library = /* @__PURE__ */ glyph(PhBooks, 'Library');
export const Lightbulb = /* @__PURE__ */ glyph(PhLightbulb, 'Lightbulb');
export const LineChart = /* @__PURE__ */ glyph(PhChartLine, 'LineChart');
export const Link = /* @__PURE__ */ glyph(PhLink, 'Link');
export const Link2 = /* @__PURE__ */ glyph(PhLink, 'Link2');
export const List = /* @__PURE__ */ glyph(PhList, 'List');
export const ListChecks = /* @__PURE__ */ glyph(PhListChecks, 'ListChecks');
export const ListFilter = /* @__PURE__ */ glyph(PhFunnelSimple, 'ListFilter');
export const ListTodo = /* @__PURE__ */ glyph(PhListChecks, 'ListTodo');
export const ListTree = /* @__PURE__ */ glyph(PhTreeStructure, 'ListTree');
export const Loader2 = /* @__PURE__ */ glyph(PhCircleNotch, 'Loader2');
export const Lock = /* @__PURE__ */ glyph(PhLock, 'Lock');
export const LockKeyhole = /* @__PURE__ */ glyph(PhLockKey, 'LockKeyhole');
export const LogIn = /* @__PURE__ */ glyph(PhSignIn, 'LogIn');
export const LogOut = /* @__PURE__ */ glyph(PhSignOut, 'LogOut');
export const Mail = /* @__PURE__ */ glyph(PhEnvelope, 'Mail');
export const MapPin = /* @__PURE__ */ glyph(PhMapPin, 'MapPin');
export const Maximize = /* @__PURE__ */ glyph(PhArrowsOut, 'Maximize');
export const Maximize2 = /* @__PURE__ */ glyph(PhArrowsOutSimple, 'Maximize2');
export const Medal = /* @__PURE__ */ glyph(PhMedal, 'Medal');
export const Megaphone = /* @__PURE__ */ glyph(PhMegaphone, 'Megaphone');
export const MemoryStick = /* @__PURE__ */ glyph(PhMemory, 'MemoryStick');
export const Menu = /* @__PURE__ */ glyph(PhList, 'Menu');
export const MessageCircle = /* @__PURE__ */ glyph(PhChatCircle, 'MessageCircle');
export const MessageSquare = /* @__PURE__ */ glyph(PhChat, 'MessageSquare');
export const MessageSquareText = /* @__PURE__ */ glyph(PhChatText, 'MessageSquareText');
export const MessagesSquare = /* @__PURE__ */ glyph(PhChats, 'MessagesSquare');
export const Mic = /* @__PURE__ */ glyph(PhMicrophone, 'Mic');
export const MicOff = /* @__PURE__ */ glyph(PhMicrophoneSlash, 'MicOff');
export const Minimize = /* @__PURE__ */ glyph(PhArrowsIn, 'Minimize');
export const Minimize2 = /* @__PURE__ */ glyph(PhArrowsInSimple, 'Minimize2');
export const Minus = /* @__PURE__ */ glyph(PhMinus, 'Minus');
export const Monitor = /* @__PURE__ */ glyph(PhMonitor, 'Monitor');
export const MonitorOff = /* @__PURE__ */ glyph(PhMonitor, 'MonitorOff');
export const MonitorPlay = /* @__PURE__ */ glyph(PhMonitorPlay, 'MonitorPlay');
export const MonitorSmartphone = /* @__PURE__ */ glyph(PhDevices, 'MonitorSmartphone');
export const MonitorUp = /* @__PURE__ */ glyph(PhMonitorArrowUp, 'MonitorUp');
export const Moon = /* @__PURE__ */ glyph(PhMoon, 'Moon');
export const MoreHorizontal = /* @__PURE__ */ glyph(PhDotsThree, 'MoreHorizontal');
export const MoreVertical = /* @__PURE__ */ glyph(PhDotsThreeVertical, 'MoreVertical');
export const MousePointer2 = /* @__PURE__ */ glyph(PhCursor, 'MousePointer2');
export const Music = /* @__PURE__ */ glyph(PhMusicNote, 'Music');
export const Network = /* @__PURE__ */ glyph(PhGraph, 'Network');
export const Package = /* @__PURE__ */ glyph(PhPackage, 'Package');
export const PackageOpen = /* @__PURE__ */ glyph(PhPackage, 'PackageOpen');
export const Palette = /* @__PURE__ */ glyph(PhPalette, 'Palette');
export const PanelLeftClose = /* @__PURE__ */ glyph(PhSidebarSimple, 'PanelLeftClose');
export const PanelLeftOpen = /* @__PURE__ */ glyph(PhSidebarSimple, 'PanelLeftOpen');
export const PanelRightClose = /* @__PURE__ */ glyph(PhSidebarSimple, 'PanelRightClose');
export const Paperclip = /* @__PURE__ */ glyph(PhPaperclip, 'Paperclip');
export const Pause = /* @__PURE__ */ glyph(PhPause, 'Pause');
export const PauseCircle = /* @__PURE__ */ glyph(PhPauseCircle, 'PauseCircle');
export const Pencil = /* @__PURE__ */ glyph(PhPencilSimple, 'Pencil');
export const PencilRuler = /* @__PURE__ */ glyph(PhPencilRuler, 'PencilRuler');
export const Percent = /* @__PURE__ */ glyph(PhPercent, 'Percent');
export const Phone = /* @__PURE__ */ glyph(PhPhone, 'Phone');
export const PhoneOff = /* @__PURE__ */ glyph(PhPhoneSlash, 'PhoneOff');
export const PictureInPicture2 = /* @__PURE__ */ glyph(PhPictureInPicture, 'PictureInPicture2');
export const PieChart = /* @__PURE__ */ glyph(PhChartPie, 'PieChart');
export const Pin = /* @__PURE__ */ glyph(PhPushPin, 'Pin');
export const Play = /* @__PURE__ */ glyph(PhPlay, 'Play');
export const PlayCircle = /* @__PURE__ */ glyph(PhPlayCircle, 'PlayCircle');
export const PlugZap = /* @__PURE__ */ glyph(PhPlug, 'PlugZap');
export const Plus = /* @__PURE__ */ glyph(PhPlus, 'Plus');
export const Power = /* @__PURE__ */ glyph(PhPower, 'Power');
export const QrCode = /* @__PURE__ */ glyph(PhQrCode, 'QrCode');
export const Radar = /* @__PURE__ */ glyph(PhRadar, 'Radar');
export const Radio = /* @__PURE__ */ glyph(PhBroadcast, 'Radio');
export const Receipt = /* @__PURE__ */ glyph(PhReceipt, 'Receipt');
export const ReceiptText = /* @__PURE__ */ glyph(PhReceipt, 'ReceiptText');
export const Redo2 = /* @__PURE__ */ glyph(PhArrowBendUpRight, 'Redo2');
export const RefreshCw = /* @__PURE__ */ glyph(PhArrowsClockwise, 'RefreshCw');
export const Reply = /* @__PURE__ */ glyph(PhArrowBendUpLeft, 'Reply');
export const Rocket = /* @__PURE__ */ glyph(PhRocketLaunch, 'Rocket');
export const RotateCcw = /* @__PURE__ */ glyph(PhArrowCounterClockwise, 'RotateCcw');
export const RotateCw = /* @__PURE__ */ glyph(PhArrowClockwise, 'RotateCw');
export const Save = /* @__PURE__ */ glyph(PhFloppyDisk, 'Save');
export const Scale = /* @__PURE__ */ glyph(PhScales, 'Scale');
export const ScrollText = /* @__PURE__ */ glyph(PhScroll, 'ScrollText');
export const Search = /* @__PURE__ */ glyph(PhMagnifyingGlass, 'Search');
export const Send = /* @__PURE__ */ glyph(PhPaperPlaneTilt, 'Send');
export const Server = /* @__PURE__ */ glyph(PhHardDrives, 'Server');
export const ServerCog = /* @__PURE__ */ glyph(PhHardDrives, 'ServerCog');
export const Settings = /* @__PURE__ */ glyph(PhGear, 'Settings');
export const Settings2 = /* @__PURE__ */ glyph(PhSliders, 'Settings2');
export const Share = /* @__PURE__ */ glyph(PhShareNetwork, 'Share');
export const Shield = /* @__PURE__ */ glyph(PhShield, 'Shield');
export const ShieldAlert = /* @__PURE__ */ glyph(PhShieldWarning, 'ShieldAlert');
export const ShieldCheck = /* @__PURE__ */ glyph(PhShieldCheck, 'ShieldCheck');
export const ShieldOff = /* @__PURE__ */ glyph(PhShieldSlash, 'ShieldOff');
export const ShoppingBag = /* @__PURE__ */ glyph(PhShoppingBag, 'ShoppingBag');
export const Shuffle = /* @__PURE__ */ glyph(PhShuffle, 'Shuffle');
export const Sigma = /* @__PURE__ */ glyph(PhSigma, 'Sigma');
export const Signal = /* @__PURE__ */ glyph(PhCellSignalFull, 'Signal');
export const SlidersHorizontal = /* @__PURE__ */ glyph(PhSlidersHorizontal, 'SlidersHorizontal');
export const Smartphone = /* @__PURE__ */ glyph(PhDeviceMobile, 'Smartphone');
export const Smile = /* @__PURE__ */ glyph(PhSmiley, 'Smile');
export const Sparkles = /* @__PURE__ */ glyph(PhSparkle, 'Sparkles');
export const Square = /* @__PURE__ */ glyph(PhSquare, 'Square');
export const Star = /* @__PURE__ */ glyph(PhStar, 'Star');
export const StickyNote = /* @__PURE__ */ glyph(PhNote, 'StickyNote');
export const Store = /* @__PURE__ */ glyph(PhStorefront, 'Store');
export const Sun = /* @__PURE__ */ glyph(PhSun, 'Sun');
export const Table2 = /* @__PURE__ */ glyph(PhTable, 'Table2');
export const Tag = /* @__PURE__ */ glyph(PhTag, 'Tag');
export const Target = /* @__PURE__ */ glyph(PhTarget, 'Target');
export const Terminal = /* @__PURE__ */ glyph(PhTerminal, 'Terminal');
export const TerminalSquare = /* @__PURE__ */ glyph(PhTerminalWindow, 'TerminalSquare');
export const TestTube2 = /* @__PURE__ */ glyph(PhTestTube, 'TestTube2');
export const Timer = /* @__PURE__ */ glyph(PhTimer, 'Timer');
export const TimerReset = /* @__PURE__ */ glyph(PhTimer, 'TimerReset');
export const Trash2 = /* @__PURE__ */ glyph(PhTrash, 'Trash2');
export const TrendingDown = /* @__PURE__ */ glyph(PhTrendDown, 'TrendingDown');
export const TrendingUp = /* @__PURE__ */ glyph(PhTrendUp, 'TrendingUp');
export const Trophy = /* @__PURE__ */ glyph(PhTrophy, 'Trophy');
export const Tv = /* @__PURE__ */ glyph(PhTelevision, 'Tv');
export const Type = /* @__PURE__ */ glyph(PhTextT, 'Type');
export const Undo2 = /* @__PURE__ */ glyph(PhArrowBendUpLeft, 'Undo2');
export const Unlink = /* @__PURE__ */ glyph(PhLinkBreak, 'Unlink');
export const Unplug = /* @__PURE__ */ glyph(PhPlugs, 'Unplug');
export const Upload = /* @__PURE__ */ glyph(PhUploadSimple, 'Upload');
export const User = /* @__PURE__ */ glyph(PhUser, 'User');
export const UserCheck = /* @__PURE__ */ glyph(PhUserCheck, 'UserCheck');
export const UserCog = /* @__PURE__ */ glyph(PhUserGear, 'UserCog');
export const UserPlus = /* @__PURE__ */ glyph(PhUserPlus, 'UserPlus');
export const UserRound = /* @__PURE__ */ glyph(PhUser, 'UserRound');
export const UserRoundX = /* @__PURE__ */ glyph(PhUserMinus, 'UserRoundX');
export const UserX = /* @__PURE__ */ glyph(PhUserMinus, 'UserX');
export const Users = /* @__PURE__ */ glyph(PhUsers, 'Users');
export const UsersRound = /* @__PURE__ */ glyph(PhUsersThree, 'UsersRound');
export const Utensils = /* @__PURE__ */ glyph(PhForkKnife, 'Utensils');
export const Variable = /* @__PURE__ */ glyph(PhFunction, 'Variable');
export const Video = /* @__PURE__ */ glyph(PhVideoCamera, 'Video');
export const VideoOff = /* @__PURE__ */ glyph(PhVideoCameraSlash, 'VideoOff');
export const Volume2 = /* @__PURE__ */ glyph(PhSpeakerHigh, 'Volume2');
export const VolumeX = /* @__PURE__ */ glyph(PhSpeakerSlash, 'VolumeX');
export const Wallet = /* @__PURE__ */ glyph(PhWallet, 'Wallet');
export const WalletCards = /* @__PURE__ */ glyph(PhWallet, 'WalletCards');
export const Wand2 = /* @__PURE__ */ glyph(PhMagicWand, 'Wand2');
export const Webhook = /* @__PURE__ */ glyph(PhWebhooksLogo, 'Webhook');
export const Wifi = /* @__PURE__ */ glyph(PhWifiHigh, 'Wifi');
export const WifiOff = /* @__PURE__ */ glyph(PhWifiSlash, 'WifiOff');
export const Workflow = /* @__PURE__ */ glyph(PhFlowArrow, 'Workflow');
export const Wrench = /* @__PURE__ */ glyph(PhWrench, 'Wrench');
export const X = /* @__PURE__ */ glyph(PhX, 'X');
export const XCircle = /* @__PURE__ */ glyph(PhXCircle, 'XCircle');
export const Zap = /* @__PURE__ */ glyph(PhLightning, 'Zap');
export const ZoomIn = /* @__PURE__ */ glyph(PhMagnifyingGlassPlus, 'ZoomIn');
export const ZoomOut = /* @__PURE__ */ glyph(PhMagnifyingGlassMinus, 'ZoomOut');

